import { render, staticRenderFns } from "./SCardTypeProductComp.vue?vue&type=template&id=117b8c02&"
import script from "./SCardTypeProductComp.vue?vue&type=script&lang=js&"
export * from "./SCardTypeProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports